import { render, staticRenderFns } from "./controlDuplicados.vue?vue&type=template&id=4db51b0e"
import script from "./controlDuplicados.vue?vue&type=script&lang=ts"
export * from "./controlDuplicados.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports